import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import TextChartTitle from '@components/text/TextChartTitle'
import CardDashboardStatGroup from '@components/card/CardDashboardStatGroup'
import _ from 'lodash'
import { IResponseOptProjectRegisteredStats } from '@interfaces/api/IDashboard'
import { ColumnChartOptions } from '@components/chart/setting'
import { Money, Num, ThY } from '@utils/utils'
import Stat from '@components/chart/Stat'
import Chart from 'react-google-charts'

const ProjectRegisteredStats = ({ title, data }: { title: string; data: IResponseOptProjectRegisteredStats }) => {
  const options = ColumnChartOptions('มูลค่าโครงการ', 'ปีงบประมาณ')
  const chartData = [
    ['ปีงบประมาณ', 'มูลค่าโครงการ', { type: 'string', role: 'annotation' }, { role: 'tooltip', type: 'string', p: { html: true } }],
    ...data.map((item) => [
      String(ThY(item.budget_year)), // ← Annotation label (appears on bar)
      parseFloat(item.total_budget),
      Money(item.total_budget),
      `<div style="padding:8px; width: 280px">
        <strong>ปีงบประมาณ ${ThY(item.budget_year)}</strong><br/>
        จำนวนผู้เข้าร่วม : ${Num(item.total_registered_count)} คน<br/>
        จำนวนโครงการ : ${item.total_projects} โครงการ<br/>
        มูลค่าโครงการ : ${Money(item.total_budget)} บาท
      </div>`,
    ]),
  ]

  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      {data.length > 1 && (
        <CardDashboardStatGroup>
          <Stat w={150} label={'จำนวนผู้เข้าร่วม'} value={Num(_.sum(data.map((r) => Number(r.total_registered_count))))} unit="คน" />
          <Stat w={150} label={'จำนวนโครงการ'} value={Num(_.sum(data.map((r) => r.total_projects)))} unit="โครงการ" />
          <Stat w={300} label={'มูลค่าโครงการ'} value={Money(_.sum(data.map((r) => parseFloat(r.total_budget))))} unit="บาท" />
        </CardDashboardStatGroup>
      )}
      {data.map((result) => {
        return (
          <CardDashboardStatGroup key={result.budget_year}>
            <Stat w={150} label={'ปีงบประมาณ'} value={ThY(result.budget_year)} />
            <Stat w={250} label={'จำนวนผู้เข้าร่วม'} value={Num(result.total_registered_count)} unit="คน" diff={result.total_registered_count_diff} />
            <Stat w={150} label={'จำนวนโครงการ'} value={Num(result.total_projects)} unit="โครงการ" diff={result.total_projects_diff} />
            <Stat w={300} label={'มูลค่าโครงการ'} value={Money(result.total_budget)} unit="บาท" diff={result.total_budget_diff} />
          </CardDashboardStatGroup>
        )
      })}
      <Chart width={'100%'} height={'500px'} chartType="ColumnChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default ProjectRegisteredStats
